module.exports = __webpack_public_path__ + "static/UNL-2346b5f3ffb4b3c493c5f4e9acdb2c0f.otf";